export default "__VITE_ASSET__9f5f9865__"